<template>
  <div :class="$style.container">
    <payment-template>
      <base-header
        :title="$t('safe.deal.title')"
        :language="language"
        slot="header"
      />

      <div slot="content">
        <deal-information
          :deal-status="deal.status"
          :payment-data="payment"
        />

        <div :class="$style.deal">
          <div :class="$style.title">
            <h2>{{ $t('deal.dispute.opened') }}</h2>
          </div>

          <div :class="$style.content">
            <p><strong>{{ deal.dispute.name }},</strong> {{ $t('deal.dispute.opened.details') }}</p>
            <p><span :class="$style.comment">{{ displayDisputeReason }}</span></p>
            <p v-html="$t('deal.dispute.opened.message', { date: formattedDealExpireDate })"></p>
          </div>

          <simple-button variant="secondary" @click="handleRedirect">
            {{ $t('deal.button.redirect') }}
          </simple-button>
        </div>
      </div>

      <base-footer slot="footer" />
    </payment-template>
  </div>
</template>

<script>
import { formatDateToCustomDate } from 'lib/utils/date';

import SimpleButton from 'molecules/common/SimpleButton';
import BaseFooter from 'molecules/base/BaseFooter';
import BaseHeader from 'organisms/base/BaseHeader';
import PaymentTemplate from 'templates/PaymentTemplate';

import DealInformation from './components/DealInformation';

export default {
  name: 'DisputedSafeDeal',
  components: {
    SimpleButton,
    BaseFooter,
    BaseHeader,
    PaymentTemplate,
    DealInformation,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
    language: {
      type: Object,
      required: true,
    },
    payment: {
      type: Object,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedDealExpireDate() {
      const { expireDate } = this.deal;

      if (this.$validate.isNull(expireDate)) {
        return '';
      }

      return formatDateToCustomDate(expireDate, 'D.MM.YYYY');
    },
    displayDisputeReason() {
      const { dispute } = this.deal;

      if (this.$validate.isUndefined(dispute) || this.$validate.isNull(dispute)) {
        return '';
      }

      if (dispute.goodsReceived) {
        return dispute.reason;
      }

      return this.$t(dispute.reason);
    },
  },
  methods: {
    handleRedirect() {
      window.location.assign(this.project.url);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +respond-to('medium')
      padding: 10px 0

  .deal
    margin-top: 40px

  .title
    margin-bottom: 20px
    padding: 15px 0
    background-image: url('@/assets/svg/custom/awaited-dispute.svg')
    background-repeat: no-repeat
    background-position: right

    h2
      margin: 0
      font-weight: 600
      font-size: 16px
      line-height: 25px
      color: rgba(33, 33, 33, 1)

      +respond-to('medium')
        font-size: 18px

  .content
    margin-bottom: 20px
    font-weight: 400
    font-style: 14px
    line-height: 21px
    color: rgba(33, 33, 33, 1)

    strong
      font-weight: 700

    p
      &:not(:last-child)
        margin-bottom: 20px

  .comment
    display: inline-block
    padding: 17px 19px
    font-weight: 500
    font-size: 12px
    line-height: 18px
    background-color: rgba(33, 33, 33, 0.1)
    border-radius: 0px 8px 8px 8px
</style>
